export default remote => ({
    all: (website, params) => remote.get(`currency/all`, {params: params}),
});
